function cryo_HasOnlyNumbers(string, possible) {
    var possible = "0123456789-";
    possible = String(possible);
    for (var i = 0; i < string.length; i++) {
        if (string.charAt(i) != 9 && string.charAt(i) != 8) {
            if (possible.indexOf(string.charAt(i)) == -1) {
                return false;
            }
        }
    }
    return true;
}

function getRoundedNumber(num, numberOfDigits) {
    const iSign = num < 0 ? -1 : 1;
    let roundedNumber = num;
    roundedNumber *= Math.pow(10, numberOfDigits);
    roundedNumber = Math.round(Math.abs(roundedNumber));
    roundedNumber /= Math.pow(10, numberOfDigits);
    roundedNumber *= iSign;

    return roundedNumber;
}

function addGroupSeparator(originalNumber, stringNumber, inputmask) {
    let numberWithSeparator = stringNumber;
    if (originalNumber >= 1000 || originalNumber <= -1000) {
        let iStart = numberWithSeparator.indexOf(".");
        if (iStart < 0)
            iStart = numberWithSeparator.length;

        iStart -= 3;
        while (iStart >= 1) {
            numberWithSeparator = numberWithSeparator.substring(0, iStart) + "," + numberWithSeparator.substring(iStart, numberWithSeparator.length);
            iStart -= 3;
        }

        if (inputmask) {
            let formattedWithMask = Inputmask.format(replaceGroupSeparatorAndRadixPoint(numberWithSeparator), inputmask);
            //se a máscara do campo de destino está removendo o ponto de separação do milhar, então deve retornar o valor original, sem o ponto
            if (!formattedWithMask.includes('.'))
                return stringNumber;
        }
    }

    return numberWithSeparator;
}

function replaceGroupSeparatorAndRadixPoint(originalNumber) {
    return cryo_ReplaceAll(cryo_ReplaceAll(cryo_ReplaceAll(originalNumber, ",", "@"), ".", ","), "@", ".");
}

function fillNumberOfDigits(stringNumber, numberOfDigitsToRound) {
    if (stringNumber.indexOf(',') > -1) {
        // ficou com numero 10,1 deve corrigir para 10,10
        if (stringNumber.split(',')[1].length === 1 && numberOfDigitsToRound == 2)
            stringNumber = stringNumber + '0';
    }
    else {
        // ficou sem casas decimais, deve completar com zeros
        if (numberOfDigitsToRound == 2)
            stringNumber = stringNumber + ',00';
        else if (numberOfDigitsToRound == 1)
            stringNumber = stringNumber + ',0';
    }

    return stringNumber;
}

function getNumberOfDigitsToRound(originalNumber, inputmask) {
    if (inputmask) {
        let formattedWithMask = Inputmask.format(replaceGroupSeparatorAndRadixPoint(originalNumber), inputmask);

        //se a máscara do campo de destino está removendo a vírgula, então deve retornar o valor arredondado para inteiro
        if (!formattedWithMask.includes(','))
            return 0;

        //se a máscara do campo de destino está deixando apenas uma casa após a vírgula, então deve retornar o valor arredondado com uma casa
        if (formattedWithMask.split(',')[1].length === 1)
            return 1;
    }


    return 2;
}

function cryo_NumberToShow(num, to) {
    if (!cryo_HasOnlyNumbers(parseFloat(num))) return "NaN";
    let inputmask;

    if (to) {        
        if (to.getAttribute('data-inputmask')) 
            inputmask = JSON.parse(`{ ${to.getAttribute('data-inputmask').replace(/'/g, '"')} }`);        
    }

    let numberOfDigitsToRound = getNumberOfDigitsToRound(num, inputmask);

    let tmpNumStr = String(getRoundedNumber(num, numberOfDigitsToRound));

    tmpNumStr = addGroupSeparator(num, tmpNumStr, inputmask);

    if (num < 0)
        tmpNumStr = "-" + tmpNumStr.substring(1, tmpNumStr.length);

    tmpNumStr = replaceGroupSeparatorAndRadixPoint(tmpNumStr);

    tmpNumStr = fillNumberOfDigits(tmpNumStr, numberOfDigitsToRound);

    return tmpNumStr;
}

function cryo_ReplaceAll(string, find, replace) {
    return String(string).split(find).join(replace);
}

function cryo_NumberToOperate(n) {
    //Apenas caracteres válidos: números, +, -, pontos e vírgulas.
    if (/[^\d.,+-]/g.test(n))
        return NaN;

    if (!cryo_HasOnlyNumbers(n)) {
        n = cryo_ReplaceAll(n, ".", "");
        n = cryo_ReplaceAll(n, ",", ".");
    }
    return parseFloat(n);
}

function getValuesByXName(xname) {
    return Array.from(document.querySelectorAll('[xname=inp' + xname + ']')).map(function (el) { return pullValue(el); });
};

function SUM(xname) {
    let vals = getValuesByXName(xname);
    return "(" + vals.join(" + ") + ")";
};

function AVG(xname) {
    let vals = getValuesByXName(xname);
    return "( (" + vals.join(" + ") + ") / " + vals.length + ")";
};

function MAX(xname) {
    let vals = getValuesByXName(xname);
    return "(" + Math.max.apply(Math, vals) + ")";
};

function MIN(xname) {
    let vals = getValuesByXName(xname);
    return "(" + Math.min.apply(Math, vals) + ")";
};

function COUNT(xname) {
    let vals = getValuesByXName(xname);
    return "(" + vals.length + ")";
};

function pullValue(field) {
    if (["text", "hidden"].indexOf(field.type) === -1) {
        throw new Error(mMsgInvalidFieldTypeMath);
    }

    if (field.value === "")
        field.value = "0";
    return cryo_NumberToOperate(field.value);
};

function cryo_Math(to, operation, supportedFunctions, index) {
    var math_Old = function (to, operation) {
        var total = "";

        if (typeof (to) != "object") {
            to = cryo_GetElementByXname("inp" + to);
            if (to.length != null) {
                cryo_alert("cryo_Math: Não foi possível localizar o objeto de destino. ");
                return;
            }
        }
        var args = operation.split(' ');

        for (var i = 0; i < args.length; i++) {
            var arg = args[i];
            var rParentesis = false;
            var lParentesis = false;
            if (!cryo_IsMathOperator(arg) && isNaN(arg)) {
                if (arg.indexOf("(") >= 0) {
                    arg = arg.substring(1, arg.length);
                    lParentesis = true;
                }
                if (arg.indexOf(")") >= 0) {
                    arg = arg.substring(0, arg.length - 1);
                    rParentesis = true;
                }

                field = cryo_GetElementByXname("inp" + arg);

                if (field.length != null) {
                    field = cryo_GetElementByXnameRow(to, "inp" + arg);
                }

                if (field.value == "") field.value = "0";
                if (lParentesis) total += "(";
                total += cryo_NumberToOperate(field.value);
                if (rParentesis) total += ")";
            } else {
                total += arg;
            }
        }
        to.value = cryo_NumberToShow(eval(total));
    };

    if (arguments.length == 2) {
        return math_Old(to, operation);
    }

    let total = operation;

    if (typeof (to) != "object") {
        to = cryo_GetElementByXname("inp" + to);
        if (to.length != null) {
            cryo_alert("cryo_Math: Não foi possível localizar o objeto de destino. ");
            return;
        }
    }

    let toXname = to.attributes["xname"].value.replace('inp', '')
    
    if (index >= 0 && document.querySelectorAll('[xname=inp' + toXname + ']').length > 1) {
        to = document.querySelectorAll('[xname=inp' + toXname + ']')[index];
    }

    try {
        //Declara os regex a partir das funções suportadas
        let rFunctionsAndFields = supportedFunctions.getRegex(true);

        total = total.replace(rFunctionsAndFields, function (fCall) {
            //Se é função, aplica a mesma
            if (supportedFunctions.getRegex(false).test(fCall))
                return eval(fCall.replace(supportedFunctions.getSanitizeRegex(), function (f) { return f.toUpperCase(); }).replace(/\(/g, "('").replace(/\)/g, "')"));
            else {
                if (!isNaN(fCall)) return " " + fCall + " ";

                //Campo simples: simplesmente puxa o valor
                let field = document.querySelectorAll('[xname=inp' + fCall + ']')[index];
                if (!field)
                    field = document.querySelectorAll('[xname=inp' + fCall + ']')[0];

                //Caso não foi encontrado o campo do formulário, é retornado o próprio caractere ou identificador.
                if (!field)
                    return " " + fCall + " ";
                
                return " " + pullValue(field) + " ";
            }
        });

        let result = eval(total);
        result = !isNaN(result) && result !== Infinity && result !== -Infinity ? cryo_NumberToShow(result, to) : mMsgInvalidMath;

        //se o evento de cálculo foi disparado por um campo a partir da segunda linha da multivalorada (index >= 0),
        //e o campo de destino tem apenas uma instância (ou seja, está fora da multivalorada ou no footer),
        //então seta o valor nesse única instância do campo
        if (index >= 0 && document.querySelectorAll('[xname=inp' + toXname + ']').length <= 1)
            index = 0;

        setElementValue(to, result, index);

    } catch (e) {
        setElementValue(to, e.message, index);
    }
}

function setElementValue(destinationElement, value, index) {
    //se existe a API de campos da automação, utiliza a mesma, para que sejam disparadas as automações
    //relacionadas ao campo
    if (typeof FieldAPI !== "undefined") {
        let destinationField = new FieldAPI(destinationElement);
        destinationField.setValue(value, index);
    }
    else
        destinationElement.value = value;
}

function cryo_IsMathOperator(s) {
    if ("+-/*()".indexOf(s) >= 0) {
        return true;
    } else {
        return false;
    }
}

//overload para provider
function cryo_sumFields(to, from) { cryo_SumFields(to, from); }

// - 16/04/2007 -
// funcao totalizadora
// objFieldTotal : id do campo onde será armazenado o somatório
// objFieldsToSum : valor da propriedade name do campo que
//                    contém os valores (todos os campos devem ter o mesmo name)
function cryo_SumFields(to, from) {
    if (typeof (to) != "object") {
        to = cryo_GetElementByXname("inp" + to);
    }
    if (typeof (from) != "object") {
        from = cryo_GetElementByXname("inp" + from);
    }

    var sums = 0;
    if (from.length) {
        for (i = 0; i < from.length; i++) {
            if (from[i].value != "") {
                sums += cryo_NumberToOperate(from[i].value);
            }
        }
        to.value = cryo_NumberToShow(sums);
    } else {
        to.value = cryo_NumberToShow(cryo_NumberToOperate(from.value));
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = {
        cryo_HasOnlyNumbers,
        getRoundedNumber,
        addGroupSeparator,
        replaceGroupSeparatorAndRadixPoint,
        fillNumberOfDigits,
        getNumberOfDigitsToRound,
        cryo_NumberToShow,
        cryo_ReplaceAll,
        cryo_NumberToOperate,
        getValuesByXName,
        SUM,
        AVG,
        MAX,
        MIN,
        COUNT,
        pullValue,
        cryo_Math,
        setElementValue,
        cryo_IsMathOperator,
        cryo_sumFields,
        cryo_SumFields
    };
};